var exports = {
  "kL": "x4c3adb35--4fe8f2--container",
  "wx": "x4c3adb35--4fe8f2--header",
  "Qq": "x4c3adb35--4fe8f2--text",
};

module.exports = exports;
